import { render } from "./TrueFalse.vue?vue&type=template&id=32a7ea9a&scoped=true"
import script from "./TrueFalse.vue?vue&type=script&lang=js"
export * from "./TrueFalse.vue?vue&type=script&lang=js"

import "./TrueFalse.vue?vue&type=style&index=0&id=32a7ea9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a7ea9a"]])

export default __exports__